// CategoryFilter.js
import React from "react";
import "./category.css";

const CategoryFilter = ({ categories, activeCategory, onSelectCategory }) => {
  return (
    <div className="category-filter">
      <button
        className={`category-button ${
          activeCategory === "All" ? "active" : ""
        }`}
        onClick={() => onSelectCategory("All")}
      >
        All
      </button>
      {categories.map((category, index) => (
        <button
          key={index}
          className={`category-button ${
            activeCategory === category ? "active" : ""
          }`}
          onClick={() => onSelectCategory(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
